const Role = {
  Admin: "Admin",
  ShipOwner: "ShipOwner",
  YardInCharge: "YardInCharge",
  Supervisor: "Supervisor",
};
export default Role;
